export default "__VITE_ASSET__CAIzKdzO__"